import { getHelpUrl } from '@change-corgi/config/help';
import type { Locale } from '@change-corgi/config/locales';
import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

export type FlashMessageCopy = {
	emphasizedText: TranslationKey;
	secondaryText: TranslationKey;
	redirectCopy: TranslationKey;
	redirectHref: string;
};

const DEFAULT_ERROR_COPY: Omit<FlashMessageCopy, 'redirectHref'> = {
	emphasizedText: translationKey('corgi.sap.preview.pre_publish_error.default_emphasized_text'),
	secondaryText: translationKey('corgi.sap.preview.pre_publish_error.default_secondary_text'),
	redirectCopy: translationKey('corgi.sap.preview.redirect.support'),
};

export const getPublishErrorMessage = (locale: Locale, publishError: string): FlashMessageCopy => {
	if (publishError.includes('session_timeout')) {
		return {
			emphasizedText: translationKey('corgi.sap.preview.pre_publish_error.default_emphasized_text'),
			secondaryText: translationKey('corgi.sap.preview.pre_publish_error.session_timeout_secondary_text'),
			redirectCopy: translationKey('corgi.sap.preview.redirect.sign_in'),
			redirectHref: '/login_or_join/redirected?redirectTo=/start-a-petition',
		};
	}

	return {
		...DEFAULT_ERROR_COPY,
		redirectHref: getHelpUrl(locale, 'contact-us'),
	};
};
